module.exports = __webpack_public_path__ + "img/icon_map_53_on_111.b122a176.png";